// extracted by mini-css-extract-plugin
export default {"image":"light_image__JTaFy color_colorLightBorder__6Pa4H"};